import React from "react";
import MoneyFormat from "../../layout/MoneyFormat";
import SingleProductReport from "../SingleProductReport";

const ProductAbout = ({product}) => {
    const {id} = product;
    return (
        <>
            <div className="card mb-4">
                <div className="card-header bg-primary text-white">
                    <h5 className="card-title mb-0">
                        <i className="fas fa-box me-2"></i>
                        Mahsulot ma'lumotlari
                    </h5>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label text-muted small">Mahsulot nomi</label>
                                <div className="fw-bold">{product?.name}</div>
                            </div>
                            <div className="mb-3">
                                <label className="form-label text-muted small">O'lchov birligi</label>
                                <div>
                                    <span className="badge bg-info">{product?.unit?.name}</span>
                                </div>
                            </div>
                            <div className="mb-3">
                                <label className="form-label text-muted small">Skladdagi soni</label>
                                <div className="fw-bold text-success">
                                    {Number(product?.in_stock).toLocaleString('uz-UZ', {minimumFractionDigits: 2, maximumFractionDigits: 2})} {product?.unit?.symbol}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label text-muted small">Mahsulot ta'rifi</label>
                                <div>{product?.description || 'Ta\'rif kiritilmagan'}</div>
                            </div>
                            <div className="mb-3">
                                <label className="form-label text-muted small">Hozirgi tan narxi</label>
                                <div className="fw-bold text-primary">
                                    <MoneyFormat value={product?.price} currency={"so'm"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            
            <div className="card mb-4">
                <div className="card-header bg-success text-white">
                    <h5 className="card-title mb-0">
                        <i className="fas fa-cogs me-2"></i>
                        Materiallar
                    </h5>
                </div>
                    <div className="card-body">
                        {
                            product?.product_materials?.length > 0 ?
                                (
                                    <div className="table-responsive">
                                        <table className="table table-sm table-striped">
                                            <thead className="table-light">
                                                <tr>
                                                    <th className="text-center">#</th>
                                                    <th>Material nomi</th>
                                                    <th className="text-end">Miqdori</th>
                                                    <th className="text-end">Material narxi</th>
                                                    <th className="text-end">Narxi</th>
                                                    <th className="text-center">O'lchov birligi</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(() => {
                                                    const rows = product.product_materials.map((item, index) => {
                                                        const materialPrice = Number(item?.material?.price || 0);
                                                        const unitValue = Number(item?.unit_value || 0);
                                                        const totalPrice = materialPrice * unitValue / (item?.material?.multiplier || 1);
                                                        
                                                        return (
                                                            <tr key={index}>
                                                                <td className="text-center">{index + 1}</td>
                                                                <td>
                                                                    <a href={`/materials/${item.material_id}`}
                                                                       rel="noreferrer" 
                                                                       className="text-decoration-none">
                                                                        {item.material?.name}
                                                                    </a>
                                                                </td>
                                                                <td className="text-end">
                                                                    <strong>{unitValue.toLocaleString('uz-UZ', {minimumFractionDigits: 0, maximumFractionDigits: 8})}</strong>
                                                                </td>
                                                                <td className="text-end">
                                                                    <span className="text-success fw-bold">
                                                                        {materialPrice.toLocaleString('uz-UZ')} so'm
                                                                    </span>
                                                                </td>
                                                                <td className="text-end">
                                                                    <span className="text-primary fw-bold">
                                                                        {Math.floor(totalPrice).toLocaleString('uz-UZ')} so'm
                                                                    </span>
                                                                </td>
                                                                <td className="text-center">
                                                                    <span className="badge bg-secondary">
                                                                        {item?.material?.unit_alternative?.symbol || item?.material?.unit?.symbol}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        );
                                                    });
                                                    
                                                    // Add total row using backend price
                                                    rows.push(
                                                        <tr key="total" className="table-warning border-top-2">
                                                            <td className="text-center"><strong>-</strong></td>
                                                            <td><strong>Jami</strong></td>
                                                            <td className="text-end"><strong>-</strong></td>
                                                            <td className="text-end"><strong>-</strong></td>
                                                            <td className="text-end">
                                                                <strong className="text-danger fs-6">
                                                                    {Number(product?.price || 0).toLocaleString('uz-UZ')} so'm
                                                                </strong>
                                                            </td>
                                                            <td className="text-center"><strong>-</strong></td>
                                                        </tr>
                                                    );
                                                    
                                                    return rows;
                                                })()}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="text-muted text-center py-3">
                                        <i className="fas fa-info-circle me-2"></i>
                                        Hech qanday material topilmadi
                                    </div>
                                )
                        }
                    </div>
                </div>
            
            <div className="card">
                <div className="card-header bg-warning text-dark">
                    <h5 className="card-title mb-0">
                        <i className="fas fa-chart-bar me-2"></i>
                        Hisobot chiqarish <small>(ishlab chiqarish va sotuv)</small>
                    </h5>
                </div>
                <div className="card-body">
                    <SingleProductReport id={id}/>
                </div>
            </div>
        </>

    )
}

export default ProductAbout;